import { ModalsConfig } from './../mockups-modal/mockups-modal.component';

export const ERROR_MODAL_MOCK: ModalsConfig[] = [
    {
        label: 'Default',
        type: 'Default',
    },
    {
        label: 'B&You',
        type: 'B&You',
    },
    {
        label: 'Customer',
        type: 'Customer',
    },
    {
        label: 'Retry',
        type: 'Retry',
    },
    {
        label: 'Partner exclusivity',
        type: 'PartnerExclusivity',
    },
    {
        label: 'Pro legal represent',
        type: 'ProLegalRepresent',
    },
    {
        label: 'Payment',
        type: 'Payment',
    },
    {
        label: 'Panenka',
        type: 'EligiblityErrorModalPanenka',
    },
    {
        label: 'Bbox byou',
        type: 'EligiblityErrorModalByou',
    },
    {
        label: 'Ftth elig',
        type: 'Ftth',
    },
];

export const SUCCESS_MODAL_MOCK: ModalsConfig[] = [];

export const INFO_MODAL_MOCK: ModalsConfig[] = [
    {
        label: 'Pro price',
        type: 'ProPrice',
    },
    {
        label: 'CDC Payment',
        type: 'CdcPayment',
    },
    {
        label: 'Scoring',
        type: 'Scoring',
    },
    {
        label: 'ClickCollectIncompatibility',
        type: 'ClickCollectIncompatibility',
    },
];

export const OTHER_MODAL_MOCK: ModalsConfig[] = [
    {
        label: 'Loading',
        type: 'Loading',
    },
    {
        label: 'Price compatibility',
        type: 'PriceCompatibility',
    },
    {
        label: 'Destination',
        type: 'Destination',
    },
];
